export default __webpack_public_path__ + "static/media/rap4.cb814cfe.jpg";